var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[(_vm.showWelcome)?_c('welcome-sprite',{on:{"complete":_vm.next}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }